<div mat-dialog-title class="!text-base">
    {{title}}
</div>

<div mat-dialog-content class="py-0">
    <form #addressForm="ngForm">
        <div class="grid sm:grid-cols-2 gap-x-4 gap-y-2">

            <!-- Tipo -->
            <mat-form-field class="w-full">
                <mat-label>Tipo</mat-label>
                <mat-select [(ngModel)]="address.idTipoDireccion" name="idTipoDireccion" required>
                    <mat-option *ngFor="let a of addresses" [value]="a.id">{{a.name}}</mat-option>
                </mat-select>
                <mat-error>
                    Completa este campo.
                </mat-error>
            </mat-form-field>

            <!-- País -->
            <mat-form-field class="w-full">
                <mat-label>País</mat-label>
                <mat-select [(ngModel)]="address.country" name="country"
                    (selectionChange)="onCountryChange($event.value)" required>
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="address.filterCountry" name="filterCountry"
                            placeholderLabel="Buscar..." noEntriesFoundLabel="'Sin Resultados'">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngIf="loadingCountries">Cargando...</mat-option>
                    <mat-option *ngFor="let c of countries | search: address.filterCountry:['name_es']" [value]="c.id">
                        {{ c.name_es }}
                    </mat-option>
                    <mat-option [value]="0" *ngIf="!loadingCountries">Otros</mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Región -->
            <mat-form-field class="w-full" *ngIf="!isPeru">
                <mat-label>Región</mat-label>
                <mat-select name="region" [(ngModel)]="address.region" required [disabled]="!isRegionEnabled">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="address.filterRegion" name="filterRegion"
                            placeholderLabel="Buscar..." noEntriesFoundLabel="'Sin Resultados'"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngIf="loadingRegions || !regions?.length">Cargando...</mat-option>
                    <mat-option *ngFor="let r of regions| search: address.filterRegion:['name']" [value]="r.id">
                        {{r.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Departamento -->
            <mat-form-field class="w-full" *ngIf="isPeru">
                <mat-label>Departamento</mat-label>
                <mat-select name="departamento" [(ngModel)]="address.departamento"
                    (selectionChange)="onDepartmentChange($event.value)" required [disabled]="!isDepartamentoEnabled">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="address.filterDepartamento" name="filterDepartamento"
                            placeholderLabel="Buscar..." noEntriesFoundLabel="'Sin Resultados'"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngIf="!isDepartamentoEnabled">Cargando...</mat-option>
                    <mat-option *ngFor="let d of department| search: address.filterDepartamento:['name']"
                        [value]="d.id">
                        {{d.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Provincia -->
            <mat-form-field class="w-full" *ngIf="isPeru">
                <mat-label>Provincia</mat-label>
                <mat-select name="provincia" [(ngModel)]="address.provincia"
                    (selectionChange)="onProvinceChange($event.value)" required [disabled]="!isProvinciaEnabled">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="address.filterProvincia" name="filterProvincia"
                            placeholderLabel="Buscar..." noEntriesFoundLabel="'Sin Resultados'">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngIf="!isProvinciaEnabled">Cargando...</mat-option>
                    <mat-option *ngFor="let p of provincias | search: address.filterProvincia:['name']" [value]="p.id">
                        {{p.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Distrito -->
            <mat-form-field class="w-full" *ngIf="isPeru">
                <mat-label>Distrito</mat-label>
                <mat-select name="distrito" [(ngModel)]="address.distrito" required [disabled]="!isDistritoEnabled">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="address.filterDistrito" name="filterDistrito"
                            placeholderLabel="Buscar..." noEntriesFoundLabel="'Sin Resultados'">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngIf="!isDistritoEnabled">Cargando...</mat-option>
                    <mat-option *ngFor="let d of distritos | search: address.filterDistrito:['name']" [value]="d.id">
                        {{d.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Código Postal -->
            <mat-form-field class="w-full">
                <mat-label>Código Postal</mat-label>
                <input matInput required type="text" autocomplete="off" name="zipCode" [(ngModel)]="address.zipCode">
                <mat-error>
                    Completa este campo.
                </mat-error>
            </mat-form-field>
        </div>
        
        <!-- Dirección -->
        <mat-form-field class="w-full">
            <mat-label>Dirección</mat-label>
            <input matInput required type="text" autocomplete="off" [(ngModel)]="address.direccion" name="direccion">
            <mat-error>
                Completa este campo.
            </mat-error>
        </mat-form-field>
    </form>
</div>

<div mat-dialog-actions align="end" class="!px-6">
    <button mat-stroked-button color="primary" class="me-4" (click)="cancel()" type="button">Cancelar</button>
    <adp-button-icon (clicked)="onSubmit(addressForm)" color="primary" [disabled]="addressForm.invalid"
        [loading]="!buttonSubmit" label="Agregar"></adp-button-icon>
</div>